import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useMemberRewards } from '../../hooks/use-member-rewards';
import { Button } from '../button/button';
import { ButtonColor } from '../button/types/color';
import { ButtonSize } from '../button/types/size';
import { ShowtimePickerFilmList } from './subcomponents/film-list';
import { ShowtimePickerMessage } from './subcomponents/message';
import { ShowtimePickerContextInstance } from './types/context';
const b = bemClassBuilder('v-showtime-picker');
/**
 * The **Showtime Picker** component renders a list of showtimes for a given set of films and sites.
 */
export const ShowtimePicker = observer(props => {
    const { config, invalidStateMessage, displayText, events } = props;
    // Load member rewards to show reward-restricted booking periods.
    useMemberRewards();
    const handleActionButtonClicked = useCallback(() => {
        var _a;
        (_a = events.onActionButtonClicked) === null || _a === void 0 ? void 0 : _a.call(events);
    }, [events]);
    const actionButton = (_jsx(Button, { className: b.element('action-button'), label: displayText.actionButtonLabel, color: ButtonColor.Primary, size: ButtonSize.Large, onClick: handleActionButtonClicked }));
    return (_jsx(ShowtimePickerContextInstance.Provider, Object.assign({ value: props }, { children: _jsx("div", Object.assign({ className: b.block() }, { children: invalidStateMessage ? (_jsx(ShowtimePickerMessage, Object.assign({}, props, { actionButton: config.actionButton.showOnMessage ? actionButton : undefined }, invalidStateMessage))) : (_jsxs(_Fragment, { children: [_jsx(ShowtimePickerFilmList, {}), config.actionButton.show && actionButton] })) })) })));
});
ShowtimePicker.displayName = 'ShowtimePicker';
